import _asyncToGenerator from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { convertToEnglishDigit } from "../../helpers/Functions";
import ApiService from "./ApiService";

var OrderApiService = /*#__PURE__*/function (_ApiService) {
  _inherits(OrderApiService, _ApiService);

  var _super = _createSuper(OrderApiService);

  function OrderApiService() {
    _classCallCheck(this, OrderApiService);

    return _super.apply(this, arguments);
  }

  _createClass(OrderApiService, [{
    key: "getOrders",
    value:
    /**
     *
     * @param {number} id
     * @param {number} page
     * @returns {Promise}
     */
    function () {
      var _getOrders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var page,
            status,
            date,
            table_id,
            params,
            res,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
                status = _args.length > 2 ? _args[2] : undefined;
                date = _args.length > 3 ? _args[3] : undefined;
                table_id = _args.length > 4 ? _args[4] : undefined;
                params = {
                  status: status,
                  date: date,
                  table_id: table_id
                };
                _context.prev = 5;
                _context.next = 8;
                return this.axios.get("providers/".concat(id, "/orders?page=").concat(page), {
                  params: params
                });

              case 8:
                res = _context.sent;
                return _context.abrupt("return", res);

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);
                return _context.abrupt("return", this.throwFetchError(_context.t0));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 12]]);
      }));

      function getOrders(_x) {
        return _getOrders.apply(this, arguments);
      }

      return getOrders;
    }()
    /**
     *
     * @param {number} providerID
     * @param {number} orderID
     * @param {string} status
     * @param {string} processingTime
     * @returns {Promise} Promise
     */

  }, {
    key: "changeOrderStatus",
    value: function () {
      var _changeOrderStatus = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(providerID, orderID, status, processingTime) {
        var formData, providerDetails, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = new FormData();
                providerDetails = {
                  processingTime: processingTime
                };
                formData.append("status", status);
                formData.append("provider_details", JSON.stringify(JSON.stringify(providerDetails)));
                _context2.prev = 4;
                _context2.next = 7;
                return this.axios.post("providers/".concat(providerID, "/orders/").concat(orderID, "/review"), formData);

              case 7:
                res = _context2.sent;
                return _context2.abrupt("return", res);

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);
                return _context2.abrupt("return", this.throwFetchError(_context2.t0));

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 11]]);
      }));

      function changeOrderStatus(_x2, _x3, _x4, _x5) {
        return _changeOrderStatus.apply(this, arguments);
      }

      return changeOrderStatus;
    }()
    /**
     *
     * @param {number} orderId
     * @param {number} providerID
     * @param {string} userPhoneNumber
     * @param {string} price
     * @param {[]} _items
     * @param {string} description
     * @param {string} deskNumber
     * @param {string} tableId
     * @param {string} address
     * @param {string} orderType
     * @param {string} deliveryFee
     * @param {string} status order status => pending - approved - denied
     * @param {string} paymentType online - offline
     * @param {string} processingTime
     * @param {boolean} isIntentionalChange
     * @returns {Promise}
     */

  }, {
    key: "createOrEditOrder",
    value: function () {
      var _createOrEditOrder = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var orderId,
            providerID,
            userPhoneNumber,
            price,
            discount,
            _items,
            description,
            deskNumber,
            tableId,
            address,
            orderType,
            deliveryFee,
            status,
            paymentType,
            processingTime,
            isIntentionalChange,
            items,
            itemIndex,
            item,
            formData,
            userDetails,
            fee,
            providerDetails,
            url,
            res,
            _args3 = arguments;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                orderId = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;
                providerID = _args3.length > 1 ? _args3[1] : undefined;
                userPhoneNumber = _args3.length > 2 ? _args3[2] : undefined;
                price = _args3.length > 3 ? _args3[3] : undefined;
                discount = _args3.length > 4 ? _args3[4] : undefined;
                _items = _args3.length > 5 ? _args3[5] : undefined;
                description = _args3.length > 6 ? _args3[6] : undefined;
                deskNumber = _args3.length > 7 ? _args3[7] : undefined;
                tableId = _args3.length > 8 ? _args3[8] : undefined;
                address = _args3.length > 9 ? _args3[9] : undefined;
                orderType = _args3.length > 10 ? _args3[10] : undefined;
                deliveryFee = _args3.length > 11 ? _args3[11] : undefined;
                status = _args3.length > 12 ? _args3[12] : undefined;
                paymentType = _args3.length > 13 ? _args3[13] : undefined;
                processingTime = _args3.length > 14 ? _args3[14] : undefined;
                isIntentionalChange = _args3.length > 15 ? _args3[15] : undefined;

                if (_items) {
                  items = {};

                  for (itemIndex in _items) {
                    item = _items[itemIndex];
                    items[+itemIndex + 1] = {
                      id: item.product.id,
                      title: item.product.title,
                      price: item.product.price,
                      quantity: item.unit,
                      discount: item.product.discount,
                      level: item.product.categoryLevel,
                      categoryId: item.product.categoryId
                    };
                  }
                }

                formData = new FormData();
                userDetails = {};

                if (orderType === 'indoor') {
                  if (tableId) formData.append('table_id', tableId);
                  if (deskNumber) Object.assign(userDetails, {
                    destination: deskNumber
                  });
                } else {
                  Object.assign(userDetails, {
                    destination: address
                  });
                }

                if (description) {
                  Object.assign(userDetails, {
                    description: description
                  });
                }

                if (deliveryFee) {
                  fee = convertToEnglishDigit(deliveryFee.toString().splitNumberFormat());
                  formData.append("delivery_fee", fee);
                  Object.assign(userDetails, {
                    delivery: {
                      fee: fee
                    }
                  });
                }

                if (orderType === 'outdoor' && processingTime) {
                  providerDetails = {
                    processingTime: processingTime
                  };
                  formData.append("provider_details", JSON.stringify(JSON.stringify(providerDetails)));
                }

                formData.append("price", +convertToEnglishDigit(price));
                formData.append("type", orderType);
                formData.append("user_details", JSON.stringify(JSON.stringify(userDetails)));
                if (items) formData.append("items", JSON.stringify(JSON.stringify(items)));
                if (discount) formData.append("discount", discount.toString());
                formData.append("payment_type", paymentType);
                formData.append('status', status);

                if (userPhoneNumber) {
                  formData.append("phone", convertToEnglishDigit(userPhoneNumber));
                }

                url = "providers/".concat(providerID, "/orders");

                if (orderId) {
                  url = "providers/".concat(providerID, "/orders/").concat(orderId);
                  formData.append("_method", "PATCH");
                  /**
                   * It's for letting the server know if something is going to change or not
                   */

                  if (isIntentionalChange) formData.append("is_intentional_change", isIntentionalChange ? '1' : '0');
                }

                _context3.prev = 33;
                _context3.next = 36;
                return this.axios.post(url, formData);

              case 36:
                res = _context3.sent;
                return _context3.abrupt("return", res);

              case 40:
                _context3.prev = 40;
                _context3.t0 = _context3["catch"](33);
                return _context3.abrupt("return", this.throwFetchError(_context3.t0));

              case 43:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[33, 40]]);
      }));

      function createOrEditOrder() {
        return _createOrEditOrder.apply(this, arguments);
      }

      return createOrEditOrder;
    }()
    /**
     *
     * @param {number} providerId
     * @param {number} orderId
     * @returns {Promise}
     */

  }, {
    key: "sendOrderLink",
    value: function () {
      var _sendOrderLink = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(providerId, orderId) {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.axios.post("providers/".concat(providerId, "/orders/").concat(orderId, "/send"));

              case 3:
                res = _context4.sent;
                return _context4.abrupt("return", res);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", this.throwFetchError(_context4.t0));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function sendOrderLink(_x6, _x7) {
        return _sendOrderLink.apply(this, arguments);
      }

      return sendOrderLink;
    }()
    /**
     *
     * @param {string} phone
     * @returns {Promise}
     */

  }, {
    key: "searchUser",
    value: function () {
      var _searchUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(phone) {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.axios.get("users/search?phone=".concat(convertToEnglishDigit(phone)));

              case 3:
                res = _context5.sent;
                return _context5.abrupt("return", res);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", this.throwFetchError(_context5.t0));

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function searchUser(_x8) {
        return _searchUser.apply(this, arguments);
      }

      return searchUser;
    }()
    /**
     *
     * @param {number} id
     * @param {number} page
     * @returns {Promise}
     */

  }, {
    key: "getOrderReports",
    value: function () {
      var _getOrderReports = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
        var page,
            res,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                page = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 1;
                _context6.prev = 1;
                _context6.next = 4;
                return this.axios.get("providers/".concat(id, "/payments?page=").concat(page));

              case 4:
                res = _context6.sent;
                return _context6.abrupt("return", res);

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](1);
                return _context6.abrupt("return", this.throwFetchError(_context6.t0));

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 8]]);
      }));

      function getOrderReports(_x9) {
        return _getOrderReports.apply(this, arguments);
      }

      return getOrderReports;
    }()
    /**
     *
     * @param {number} id
     * @param {number[]} orderIds
     * @returns {Promise}
     */

  }, {
    key: "deleteOrderReceipt",
    value: function () {
      var _deleteOrderReceipt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id, orderId) {
        var res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.axios.delete("providers/".concat(id, "/orders/").concat(orderId));

              case 3:
                res = _context7.sent;
                return _context7.abrupt("return", res);

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", this.throwFetchError(_context7.t0));

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 7]]);
      }));

      function deleteOrderReceipt(_x10, _x11) {
        return _deleteOrderReceipt.apply(this, arguments);
      }

      return deleteOrderReceipt;
    }()
  }]);

  return OrderApiService;
}(ApiService);

var orderApiService = new OrderApiService();
export default orderApiService;